import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { WebhooksComponent } from './webhooks.component';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';


@NgModule({
  declarations: [WebhooksComponent],
  exports: [WebhooksComponent],
  entryComponents: [WebhooksComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatTableModule,
    MatToolbarModule,
    WsUiModule,
  ]
})
export class WebhooksModule { }
